import React from 'react';
import { select } from 'd3';
import '../css/Graph.css';
import GroupedBarChart from '../../lib/GroupedBarChart';

export default class GroupedBarGraph extends React.Component {
  componentDidMount() {
    const margins = {top: 30, bottom: 40, left: 60, right: 200};
    const trnTime = this.props.transitionTime;
    this.graph = new GroupedBarChart(this.svg, 500, 1200, 
      margins, trnTime, this.tooltipDiv);

    if (this.props.onGraphClick) this.graph.setOnClick(this.props.onGraphClick);

    if (this.graph) {
      this.graph.setData(this.props.data);
      this.graph.setUnits(this.props.units);
      this.graph.drawChart();
    }
  }

  componentDidUpdate() {
    this.graph.setData(this.props.data);
    this.graph.setUnits(this.props.units);
    this.graph.setTransitionTime(this.props.transitionTime);
    this.graph.drawChart();
  }

  render() {
    return (
      <div className="groupedBarGraphContainer">
        <svg 
          ref={(svg) => this.svg = select(svg)}>
        </svg>
        <div 
          className='tooltip'
          ref={(div) => this.tooltipDiv = select(div)}>
        </div>
      </div>
    );      
  }
}
